<template>
    <div class="item">
        <button class="item__title" @click="toggle" :class="{ 'is-active': isActive }">
            {{ item.Title }}
            <span class="icon"></span>
        </button>
        <Transition name="accordion" @enter="enter" @after-enter="afterEnter" @leave="leave">
            <div class="item__body" v-if="isActive">
                <div class="answer" v-html="item.BodyText"></div>
                <div class="controls" v-if="item.Link.Text && item.Link.Url">
                    <a
                        :href="item.Link.Url"
                        :target="item.Link.Target"
                        class="btn-default btn-default--1"
                        >{{ item.Link.Text }}</a
                    >
                </div>
            </div>
        </Transition>
    </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import type { Ref } from 'vue';

import { IAccordionItem } from '../interface/accordion.model';

defineProps<{
    item: IAccordionItem;
}>();

const isActive: Ref<boolean> = ref(false);

const toggle = () => {
    isActive.value = !isActive.value;
};

const enter = (el: HTMLElement) => {
    el.style.height = 'auto';

    const height = getComputedStyle(el).height;
    el.style.height = '0';

    getComputedStyle(el);

    setTimeout(() => {
        el.style.height = height;
    });
};

const afterEnter = (el: HTMLElement) => {
    el.style.height = 'auto';
};

const leave = (el: HTMLElement) => {
    el.style.height = getComputedStyle(el).height;

    getComputedStyle(el);

    setTimeout(() => {
        el.style.height = '0';
    });
};
</script>
